import type { Branch } from '@interfaces/financialProduct';
import type { TranslatedString } from '@interfaces/shared';
import type { DraggableProvided } from 'react-beautiful-dnd';

export interface Security extends Branch {
  color:
    | 'supportOne'
    | 'supportTwo'
    | 'supportThree'
    | 'supportFour'
    | 'supportFive'
    | 'supportSix';
}

export type ColumnConfig = {
  enabled: boolean;
  label: TranslatedString;
};

export type SecurityTableColumns = {
  security: ColumnConfig;
  assetClass: ColumnConfig;
  taxRank: ColumnConfig;
  targetPercentage: ColumnConfig;
  buttonRemoveSecurity: {
    enabled: boolean;
  };
};

export type SecurityTableOptions = {
  securityAllocationChart: {
    columns: [SecurityTableColumns];
  };
};

export type DragProps = {
  innerRef: DraggableProvided['innerRef'];
  draggableProps: DraggableProvided['draggableProps'];
  dragHandleProps: DraggableProvided['dragHandleProps'];
  /** When drag is disabled, still provides a handle node for react-beautiful-dnd (flat mode). */
  rowHandleProps?: DraggableProvided['dragHandleProps'];
  isDragging: boolean;
};

type ColumnConfigKey = Exclude<
  keyof SecurityTableColumns,
  'buttonRemoveSecurity'
>;

type ColumnDef = {
  width: string;
  key: ColumnConfigKey;
  sortKey: string;
};

export const COLUMNS: Record<string, ColumnDef> = {
  SECURITY: {
    width: '50%',
    key: 'security',
    sortKey: 'financialProduct.ticker',
  },
  ASSET_CLASS: {
    width: '20%',
    key: 'assetClass',
    sortKey: 'financialProduct.primaryAssetClass.name',
  },
  TAX_RANK: {
    width: '15%',
    key: 'taxRank',
    sortKey: 'taxRank',
  },
  TARGET_PERCENTAGE: {
    width: '15%',
    key: 'targetPercentage',
    sortKey: 'percentage',
  },
};

export const findSecurityIndex = (arr: Security[], target: Security): number =>
  arr.findIndex((s) => s.financialProduct.id === target.financialProduct.id);

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getItemStyle = (_isDragging: boolean, draggableStyle: any) => ({
  userSelect: 'none',
  padding: 0.5,
  margin: 0,
  background: 'white',
  ...draggableStyle,
  height: '50px',
  width: '800px',
});
